import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { Sector } from '../../../../app/models/Sector';

type Props = {
    sectorDataForm: Sector;
    setSectorDataForm: (sector: Sector) => void;
    errorFields?: any;
};

const SectorForm = ({ sectorDataForm, setSectorDataForm, errorFields }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setSectorDataForm({ ...sectorDataForm, [name]: value });
    };

    return (
        <>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Nombre</label>
                <div className="col-md-9">
                    <input
                        name="name"
                        id="name"
                        type="text"
                        className={`form-control ${fieldHasError('name')}`}
                        value={sectorDataForm.name}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('name')}
                        placeholder="Ingrese el nombre del sector"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('name')}
                    </div>
                </div>
            </div>

            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Regla de Negocio</label>
                <div className="col-md-9">
                    <select
                        name="sector_business_rules_enum"
                        id="sector_business_rules_enum"
                        className={`form-select ${fieldHasError('sector_business_rules_enum')}`}
                        value={sectorDataForm.sector_business_rules_enum || ''}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('sector_business_rules_enum')}
                    >
                        <option value="">Seleccione una regla de negocio</option>
                        <option value="Venta_Producto_Flores">Venta de Producto (Flores)</option>
                        <option value="Venta_Servicio_TransporteCarga">Venta de Servicio (Transporte de Carga)</option>
                    </select>
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('sector_business_rules_enum')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SectorForm;
